import axios from 'axios';

// Fixes AUDIT_REPORT M5: the backend URL was previously hardcoded to
// http://<hostname>:5000 in two separate places (here and in
// ExportButton.js), which breaks as soon as the app is served over HTTPS
// or from behind a reverse proxy on a normal port. REACT_APP_API_URL is a
// standard Create React App build-time env var (see client/.env.example) —
// when it isn't set, we fall back to the old localhost:5000 behavior so
// local development is unaffected.
function resolveApiBase() {
  if (process.env.REACT_APP_API_URL) {
    return { api: process.env.REACT_APP_API_URL.replace(/\/$/, ''), upload: process.env.REACT_APP_UPLOAD_URL || process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '') };
  }
  var host = window.location.hostname;
  var backendPort = '5000';
  var base = (host === 'localhost' || host === '127.0.0.1')
    ? 'http://localhost:' + backendPort
    : 'http://' + host + ':' + backendPort;
  return { api: base + '/api', upload: base };
}

var resolved = resolveApiBase();
window.UPLOAD_BASE = resolved.upload;

var api = axios.create({
  baseURL: resolved.api,
});

api.interceptors.request.use(function(config) {
  var token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// Fixes AUDIT_REPORT M4: previously a 401 (expired/invalid token, or an
// unauthenticated request now that the backend actually enforces auth) had
// no special handling — the UI would just show broken/empty pages. Now we
// clear the stale session and send the user back to login.
api.interceptors.response.use(
  function(response) { return response; },
  function(error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
